export default __webpack_public_path__ + "static/media/dole-juice-bg@2x.bf4142b2.png";